<template lang="pug">
form(@submit.prevent='onConfirm')
  modal.active(
    :active='showModal'
    @close='$router.back()',
    :title='`Alterar Prazo para Regularizar do Documento (${current.numero}/${current.ano})`'
  )
    div(slot='modal-body')
      .divider
      form-group(label="Data atual para regularizar")
        div {{ current.regularizar_em | date('DD/MM/YYYY') }}
      .columns
        .column
          form-group(label="Dias de prazo")
            int.form-input(v-model='prazo')
        .column
          form-group(label="Contar a partir de")
            datepicker(v-model='dataBase')
      form-group(label="Nova data para regularizar" :validation="$v.params.regularizar_em")
        datepicker(
          v-model="$v.params.regularizar_em.$model"
          format="DD/MM/YYYY"
          disabled
        )
      form-group(label="Informe o motivo para alterar o prazo" :validation="$v.params.motivo")
        textarea.form-input(v-model="$v.params.motivo.$model" rows="4")
    div(slot='modal-footer')
      button.btn.btn-primary(
        :disabled='$v.$invalid || loading',
        :class='{ loading }'
      )
        btn-content(name='confirm' label="Salvar")
</template>

<script>
import toastErrors from '@/lib/errors/toastErrors'
import { minLength, required } from 'vuelidate/lib/validators'

export default {
  vuex: {
    'fiscalizacao/docs': {
      state: ['current'],
      actions: ['fetchPrazoRegularizar'],
    },
  },
  data() {
    return {
      params: {
        motivo: '',
        regularizar_em: '',
        prazo_adicional: 0,
        partindo_de: '',
      },
      prazo: 0,
      dataBase: null,
      loading: false,
      showModal: true,
    }
  },
  methods: {
    async onConfirm() {
      try {
        this.loading = true
        const { id } = this.current
        await this.fetchPrazoRegularizar({ id, params: this.params })
        this.$toaster.success('Alterado Prazo Regularizar com sucesso')
        this.$router.back()
      } catch (e) {
        toastErrors(e)
      } finally {
        this.loading = false
      }
    },
    calcRegularizarEm(data, prazo) {
      const d = new Date(data)
      d.setDate(d.getDate() + prazo)
      if (d.getDay() === 0) {
        d.setDate(d.getDate() + 1)
      }
      if (d.getDay() === 6) {
        d.setDate(d.getDate() + 2)
      }
      this.params.prazo_adicional = prazo
      this.params.partindo_de = new Date(data).toJSON()
      this.params.regularizar_em = d.toJSON()
    },
  },
  created() {
    this.dataBase = this.current.regularizar_em
  },
  watch: {
    prazo(newPrazo) {
      this.calcRegularizarEm(this.dataBase, newPrazo)
    },
    dataBase(newDate) {
      this.calcRegularizarEm(newDate, this.prazo)
    },
  },
  validations: {
    params: {
      motivo: {
        required,
        minLength: minLength(10),
      },
      regularizar_em: { required },
      prazo_adicional: {},
      partindo_de: {},
    },
  },
}
</script>
